module.exports = __webpack_public_path__ + "img/GEMZ-alt.5125e24d.svg";